import { gql } from "../../../../../gql/__generated__/gql";

export const SIGN_UP_NEW_USER = gql(`
  mutation signUpNewUser($input: SignUpNewUserInput!) {
    signUpNewUser(input: $input)
  }
`);

export const CREATE_COLLAB = gql(`
  mutation createCollab($input: CreateCollabInput!) {
    createCollab(input: $input)
  }
`);

export const ACCEPT_COLLAB = gql(`
  mutation acceptCollab($collabId: String!) {
    acceptCollab(collabId: $collabId)
  }
`);

export const DECLINE_COLLAB = gql(`
  mutation declineCollab($collabId: String!) {
    declineCollab(collabId: $collabId)
  }
`);

export const CHANGE_COLLAB_OFFER = gql(`
  mutation changeCollabOffer($input: ChangeCollabOfferInput!) {
    changeCollabOffer(input: $input)
  }
`);

export const SUBMIT_COLLAB_CONTENT = gql(`
  mutation submitCollabContent($input: SubmitCollabContentInput!) {
    submitCollabContent(input: $input)
  }
`);

export const ACCEPT_COLLAB_CONTENT = gql(`
  mutation acceptCollabContent($collabId: String!, $contentId: String!) {
    acceptCollabContent(collabId: $collabId, contentId: $contentId){
      isAllContentApproved
    }
  }
`);
